import { useCreation } from 'ahooks'

import { AuthorizeOptions } from '../../types/authorize'
import { useHasPermissionFn } from '../useHasPermissionFn'

/**
 * 过滤类似于 menu 或者 tabs 组件中的 items 配置
 */
export const useAutorizedItems = <T extends AuthorizeOptions>(items: T[]) => {
  const hasPermission = useHasPermissionFn()
  return useCreation(() => {
    const authorizedItems = items.filter(item =>
      hasPermission(item.uuid, item.onlyAdministrator)
    )
    return authorizedItems
  }, [items, hasPermission])
}
